module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('p', {
    staticClass: "centerImage00"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/toc.jpg",
      "width": "50%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_title001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ded001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9780545746076_ch001"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Peggy Sue")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water, water everywhere")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ship’s log")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gibbons and ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I, Kensuke")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch006",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abunai!")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All that silence said")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everyone dead in Nagasaki")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The night of the turtles")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Killer men come")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_bm001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_bm002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_ata001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545746076_copy001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28848895","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545746076_toc001.vue
// module id = 63
// module chunks = 0